import React from 'react';

import { cn } from '@/lib/utils';

interface InspectorPropertyRowProps {
  /** Visible label on the left side. */
  label: string;
  /** Optional helper text rendered below the label. */
  helper?: string;
  /** The value or interactive control (text, picker, badge, etc.). */
  children: React.ReactNode;
  className?: string;
}

/**
 * Canonical Inspector property row: label on the left, value/picker on the right.
 * Used by body components (PostBody, ImageBody, etc.) to render structured
 * properties — caption, schedule date, platforms, status, etc.
 */
export const InspectorPropertyRow: React.FC<InspectorPropertyRowProps> = ({
  label,
  helper,
  children,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex items-start justify-between gap-3 py-3 border-b border-border/30 last:border-b-0',
        className,
      )}
    >
      <div className="min-w-0 shrink-0">
        <p className="text-detail font-medium text-foreground/80">{label}</p>
        {helper ? <p className="text-micro text-muted-foreground mt-0.5">{helper}</p> : null}
      </div>
      <div className="min-w-0 flex-1 text-right text-sm text-foreground">{children}</div>
    </div>
  );
};
